import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setLanguage } from 'ducks/auth'
import { getLocation } from 'ducks/router'
import { useLanguage } from 'hooks'

const useAuthMutations = () => {
  const dispatch = useDispatch()

  const handleSwitchLanguage = React.useCallback(
    ({ code }: { code?: string }) => {
      dispatch(setLanguage(code))
    },
    [dispatch],
  )

  return { handleSwitchLanguage }
}

export const useAuthLayout = () => {
  const location = useSelector(getLocation)
  const language = useLanguage()

  const { handleSwitchLanguage } = useAuthMutations()

  const { type } = location

  return {
    state: { language, type },
    handlers: { handleSwitchLanguage },
  }
}
